import { use } from 'react'

import { UiContext } from './Context'

export const useHelpDrawer = () => {
  const { showHelpDrawer } = use(UiContext)

  return showHelpDrawer
}
